import React, { useState } from 'react'
import { BillingContext } from 'src/components/pages/payment/billing-form/context/billingContext'
import { hasPermissionFunction } from 'src/helper/HasPermission'

type BillingProviderProps = {
  children: React.ReactNode
}

export const BillingProviderContext: React.FunctionComponent<BillingProviderProps> = ({ children }) => {
  const [reservationIds, setReservationIds] = useState<number[]>([])
  const [paymentData, setPaymentData] = useState<any>({
    business_unit_info: null,
    work_unit_info: null,
    selectedBusinessUnit: null,
    payments: null,
    reservations_info: null,
    user_info: null,
    observation_internal: null,
    force_approve:hasPermissionFunction('billingform', 'approve') ? true : false
  })
  const [paymentCurrecies, setPaymentCurrecies] = useState<any[]>([])
  const [paymentExchanges, setPaymentExchanges] = useState<any[]>([])
  const [itemsSelected, setItemsSelected] = useState<any[]>([])
  const [paymentCredit, setPaymentCredit] = useState<any[]>([])
  const [currency, setCurrency] = useState<any>({})
  const [isReservationOption, setIsReservationOption] = useState<boolean>(false)
  return (
    <BillingContext.Provider
      value={{
        reservationIds,
        setReservationIds,
        paymentData,
        setPaymentData,
        paymentCurrecies,
        setPaymentCurrecies,
        paymentExchanges,
        setPaymentExchanges,
        itemsSelected,
        setItemsSelected,
        paymentCredit,
        setPaymentCredit,
        currency,
        setCurrency,
        isReservationOption,
        setIsReservationOption,
      }}
    >
      {children}
    </BillingContext.Provider>
  )
}